import LoadingMeter from './LoadingMeter'

export default LoadingMeter
